import en from './en';
import zh from './zh';
import sc from './sc';
const translations= {
  en,
  zh,
  sc
};

export default translations;